interface TableColumn {
  label: string;
  key: string;
  showArrow?: boolean;
}

export const paidChannelsTableHeaderData: TableColumn[] = [
  {
    label: "Campaign week",
    key: "campaign",
    showArrow: false,
  },
  {
    label: "Views",
    key: "views",
    showArrow: true,
  },
  {
    label: "Clicks",
    key: "clicks",
    showArrow: true,
  },
  {
    label: "CPC",
    key: "cpc",
    showArrow: true,
  },
  {
    label: "CTR",
    key: "ctr",
    showArrow: true,
  },
  {
    label: "Search traffic",
    key: "searchTraffic",
    showArrow: false,
  },
  {
    label: "Cost",
    key: "cost",
    showArrow: true,
  },
];

export const paidChannelTableRowData = [
  {
    campaign: "Mercedes R&F v40-43",
    views: 5457801,
    clicks: 5457,
    cpc: 25.36,
    ctr: "0.10%",
    searchTraffic: 3533,
    cost: 144539,
  },
  {
    campaign: "BMW R&F v40-43",
    views: 4921849,
    clicks: 5445,
    cpc: 22.41,
    ctr: "0.10%",
    searchTraffic: 3072,
    cost: 89844,
  },
  {
    campaign: "Service Market R&F v40",
    views: 3807955,
    clicks: 4153,
    cpc: 21.66,
    ctr: "0.10%",
    searchTraffic: 3067,
    cost: 74536,
  },
  {
    campaign: "M Cars R&F v40-43",
    views: 3765173,
    clicks: 3786,
    cpc: 20.61,
    ctr: "0.10%",
    searchTraffic: 3048,
    cost: 60017,
  },
  {
    campaign: "Mercedes LCV v40-43",
    views: 3742808,
    clicks: 3362,
    cpc: 19.07,
    ctr: "0.09%",
    searchTraffic: 2892,
    cost: 51425,
  },
  {
    campaign: "Xpeng STHLM R&F v42",
    views: 3356119,
    clicks: 3265,
    cpc: 18.5,
    ctr: "0.09%",
    searchTraffic: 2841,
    cost: 47839,
  },
  {
    campaign: "Lexus Sthlm v41",
    views: 2816765,
    clicks: 3194,
    cpc: 18.47,
    ctr: "0.10%",
    searchTraffic: 2068,
    cost: 34714,
  },
  {
    campaign: "MINI R&F v40-43",
    views: 2106246,
    clicks: 2342,
    cpc: 18.39,
    ctr: "0.08%",
    searchTraffic: 1250,
    cost: 32807,
  },
];

export const paidChannelSumAssuredData = [
  { label: "Total", value: "Total" },
  { label: "totalViews", value: "38,855,595" },
  { label: "totalClicks", value: "117,285" },
  { label: "averageCPC", value: "KR 10.19" },
  { label: "averageCTR", value: "0.32%" },
  { label: "searchTraffic", value: "28,088" },
  { label: "Total Cost", value: " KR 1,194,787" },
];

export const channelTrafficTableHeadersData = [
  "Channel",
  "Visit",
  "% Δ",
  "Leads Car",
  "% Δ",
  "Lead SM",
  "% Δ",
];

export const channelTrafficRowsData = [
  {
    channel: "Organic Search",
    visit: "457 801",
    visitChange: "9.9%",
    leadsCar: "1,288.63",
    leadsCarChange: "-0.2%",
    leadSM: "3,533",
    leadSMChange: "9.9%",
  },
  {
    channel: "Direct Traffic",
    visit: "921 849",
    visitChange: "38.7%",
    leadsCar: "4,233.12",
    leadsCarChange: "19.5%",
    leadSM: "3,072",
    leadSMChange: "-38.7%",
  },
  {
    channel: "Paid Search",
    visit: "807 955",
    visitChange: "-5.1%",
    leadsCar: "2,45.188",
    leadsCarChange: "-45.4%",
    leadSM: "3,067",
    leadSMChange: "5.1%",
  },
  {
    channel: "Newsletter",
    visit: "765 173",
    visitChange: "-2.9%",
    leadsCar: "1,288.63",
    leadsCarChange: "21.6%",
    leadSM: "3,048",
    leadSMChange: "2.9%",
  },
  {
    channel: "Paid Social",
    visit: "742 808",
    visitChange: "86.2%",
    leadsCar: "4,233.12",
    leadsCarChange: "33.4%",
    leadSM: "2,892",
    leadSMChange: "86.2%",
  },
  {
    channel: "Referral",
    visit: "356 119",
    visitChange: "44.7%",
    leadsCar: "2,45.188",
    leadsCarChange: "98.1%",
    leadSM: "2,841",
    leadSMChange: "-44.7%",
  },
];

export const channelTrafficSumAssuredData = [
  { label: "total", value: "Total" },
  { label: "visits", value: "1,855,595" },
  { label: "percentage", value: "21%" },
  { label: "leadsCar", value: "2,065" },
  { label: "leaderCarPercentage", value: "12.8%" },
  { label: "leadSm", value: "28,088" },
  { label: "leadSmPercentage", value: "-14.8%" },
];

export const channelTrafficChangeLabels = [
  "percentage",
  "leaderCarPercentage",
  "leadSmPercentage",
];
